import React, {CSSProperties, FC, useCallback, useEffect, useMemo, useState} from 'react'
import Modal from 'src/components/common/Modal/Modal'
import {getUserFeedback, updateUserFeedback} from 'src/api/userFeedback';
import {UserFeedbackResponse} from 'src/models/UserFeedback';
import { Rating } from 'react-simple-star-rating'

interface Props {
  onClose: (p: boolean) => void
  currentChatId: number
  attribute: string
  nextAtom: string
}

const FeedbackModal: FC<Props> = ({ onClose, currentChatId, attribute, nextAtom }) => {
  const [feedbackValue, setFeedbackValue] = useState(0)
  const [isSubmitted, setIsSubmitted] = useState(false)

  useEffect(() => {
    getUserFeedback(currentChatId, attribute).then((res: UserFeedbackResponse) => {
      const value = res.feedbackValue || 0;
      setFeedbackValue(value);
      setIsSubmitted(value > 0);
    })
  }, [currentChatId, attribute])

  const submitHandler = useCallback(() => {
    function submitForm() {
      updateUserFeedback({
        nextAtom: nextAtom,
        attributeName: attribute,
        feedbackValue: feedbackValue,
        chatId: currentChatId
      }).then(isSuccess => {
        if (isSuccess) {
          onClose(false)
        }
      })
    }
    submitForm()
  }, [onClose, feedbackValue])

  const handleRating = (rate: number) => {
    setFeedbackValue(rate)
  }

  const feedbackButtons = useMemo(() => {
    if (isSubmitted) return [];
    return ([
      {
        title: 'Submit',
        className: 'submitButton',
        callback: submitHandler,
        disable: feedbackValue === 0
      }
    ])
  }, [feedbackValue, submitHandler, isSubmitted])

  const feedbackModalTitle = useMemo(() => {
    return 'Leave your feedback here'
  }, [feedbackValue])

  const svgStyles: CSSProperties = {
    display: 'inline',
    margin: '0 5px', // optional: spacing
  };
  const tooltipStyle: CSSProperties = {
    backgroundColor: 'white',
    color: 'black',
    marginLeft: '0'
  };

  return (
    <Modal
      title={feedbackModalTitle}
      buttons={feedbackButtons}
      onClose={onClose}>
      <Rating
        tooltipStyle={tooltipStyle}
        SVGstyle={svgStyles}
        showTooltip={true}
        tooltipArray={attribute.includes('feedback_satisfaction') ? ['Very Dissatisfied', 'Dissatisfied', 'Neutral', 'Satisfied', 'Very Satisfied'] : ['Strongly Disagree', 'Disagree', 'Neutral', 'Agree', 'Strongly Agree']}
        tooltipDefaultText={'Your rate'}
        initialValue={feedbackValue}
        onClick={handleRating}
        readonly={isSubmitted}
      />
    </Modal>
  )
}

export default FeedbackModal
